import React from "react";
import { ETLCodes } from "../locales";
import { showError, showSuccess } from "nsitools-react";
import { useTl } from "./useTl";
import { useDialog } from "../contexts";

export interface IuseDeleteApi<T> {
  deleteApiFn: (data: T) => Promise<any> | any;
  onDeletedFn?: () => void;
}

export function useDeleteApi<T>(options: IuseDeleteApi<T>) {
  const { showDialog } = useDialog();

  const { deleteApiFn, onDeletedFn } = options;

  const { t } = useTl();
  const [deleting, setDeleting] = React.useState(false);
  const deleteItem = React.useCallback(
    (data: T) => {
      showDialog({
        message: t(ETLCodes.DeleteConfirmationMessage),
        title: t(ETLCodes.DeleteDialogTitle),
        onConfirmed: async () => {
          try {
            setDeleting(true);
            await deleteApiFn(data);
            onDeletedFn();
            showSuccess(t(ETLCodes.DeleteSuccess));
          } catch (error) {
            showError(t(ETLCodes.Error));
          }
          setDeleting(false);
        },
      });
    },
    [deleteApiFn, onDeletedFn, showDialog, t]
  );

  return {
    deleteItem,
    deleting,
  };
}
